import axios from "axios";
import {API_BASE_URL, BASE_URL} from "./consts";

export const getInvoices = async () => {
	try {
		const token = sessionStorage.getItem("token");
		const sehId = sessionStorage.getItem("sehId");

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/invoices?filterBySeh=${sehId}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting invoices:", error);
		throw error;
	}
};

export const getInvoiceById = async (id) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/invoices/${id}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting invoice by id:", error);
		throw error;
	}
};

export const getInvoicesBySehId = async (sehId) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${BASE_URL}/api/invoice?seh_id=${sehId}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting invoices by sehId:", error);
		throw error;
	}
};

export const getUniqueInvoices = async () => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `GET`,
			url: `${BASE_URL}/api/invoice-uniques`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting unique invoices:", error);
		throw error;
	}
};

export const getLastInvoice = async () => {
	try {
		const token = sessionStorage.getItem("token");
		const sehId = sessionStorage.getItem("sehId");

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/invoices-last-number?sehId=${sehId}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting last invoice:", error);
		throw error;
	}
};

export const postReceivingInvoice = async (
	invoiceId,
	invoiceUniqueIds,
	blockId
) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `POST`,
			url: `${BASE_URL}/api/invoice-recieve`,
			data: {
				invoiceId,
				invoiceUniqueIds,
				blockId,
			},
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error receiving invoice:", error);
		throw error;
	}
};

export const postCreatingInvoice = async (data) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `POST`,
			url: `${BASE_URL}/api/invoice-creation`,
			data,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error creating invoice:", error);
		throw error;
	}
};

export const putInvoice = async (data) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `PUT`,
			url: `${BASE_URL}/api/invoice`,
			data,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error editing invoice:", error);
		throw error;
	}
};

export const deleteInvoice = async (id) => {
	try {
		const token = sessionStorage.getItem("token");

		const config = {
			method: `DELETE`,
			url: `${API_BASE_URL}/gotoviy/invoices/${id}`,
			data: {id},
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error deleting invoice:", error);
		throw error;
	}
};

export const getReceivingInvoiceByDate = async (date) => {
	try {
		const token = sessionStorage.getItem("token");

		const fixedDate = new Date(
			date.getFullYear(),
			date.getMonth(),
			date.getDate(),
			5,
			0,
			0
		);

		const formattedDate = fixedDate.toISOString().split("T")[0];

		const config = {
			method: `GET`,
			url: `${API_BASE_URL}/gotoviy/invoices-history?date=${formattedDate}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting receiving invoices:", error);
		throw error;
	}
};

export const getNakladnoySerialsById = async (id) => {
	try {
		const baseUrl = API_BASE_URL;
		const token = sessionStorage.getItem("token");

		const config = {
			method: "GET",
			url: `${baseUrl}/gotoviy/invoices-serials/${id}`,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error getting nakladnoy serials:", error);
		throw error;
	}
};

export const editInvoice = async (id, data) => {
	try {
		const baseUrl = API_BASE_URL;
		const token = sessionStorage.getItem("token");

		const config = {
			method: "PATCH",
			url: `${baseUrl}/gotoviy/invoices/${id}`,
			data,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error editing invoice:", error);
		throw error;
	}
};

export const createInvoice = async (data) => {
	try {
		const baseUrl = API_BASE_URL;
		const token = sessionStorage.getItem("token");

		const config = {
			method: "POST",
			url: `${baseUrl}/gotoviy/invoices`,
			data,
			headers: {
				"Content-Type": "application/json",
				...(token && {Authorization: `Bearer ${token}`}),
			},
		};

		const response = await axios(config);
		return response.data;
	} catch (error) {
		console.error("Error creating invoice:", error);
		throw error;
	}
};
